<!-- @format -->

<ad-favorite-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_recruitment">公募案件を探す</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area">
      <div class="tab-menu margin-spacing-4_bottom">
        <ul class="tab-menu-list">
          <li class="tab-menu-list-item"><a href="/ad">公募案件一覧</a></li>
          <li class="tab-menu-list-item">
            <a href="/ad/entried">エントリー中</a>
          </li>
          <!-- prettier-ignore -->
          <li class="tab-menu-list-item { state.type=='interest' ? 'is-active' : '' }">
            <a href="/ad/interest">あなたの「気になる」</a>
          </li>
          <!-- prettier-ignore -->
          <li class="tab-menu-list-item { state.type=='interested' ? 'is-active' : '' }">
            <a href="/ad/interested">クライアント様からの「気になる」
              <span
                if="{ di.Sidebar.state.interested }"
                class="badge badge-unread"
              ></span>
            </a>
          </li>
        </ul>
      </div>
      <!--/.tab-menu-->

      <div class="tab_contents active">
        <div class="container_sort margin-spacing-2_bottom">
          <div class="box_sort">
            <div class="sort-menu margin-spacing-2_right">
              <select
                name="limit"
                class="sort-list"
                onchange="{(e)=>changeLimit(e)}"
              >
                <option value="10">10件</option>
                <option value="20">20件</option>
                <option value="50">50件</option>
              </select>
            </div>
            <!--/.sort-menu-->
            <div class="sort-menu">
              <select
                name="order"
                class="sort-list"
                onchange="{(e)=>changeOrder(e)}"
              >
                <option value="0">新しい順</option>
                <option value="1">古い順</option>
                <!--
                <option value="0">最新</option>
                <option value="1">報酬料金が高い順</option>
                <option value="2">報酬料金が少ない順</option>
                <option value="3">文字数が多い順</option>
                <option value="4">文字数が少ない順</option>
                -->
              </select>
            </div>
            <!--/.sort-menu-->
          </div>
          <!--/.box_sort-->
          <p class="search_number" if="{ state.pager.total > 0}">
            全{ state.pager.total }件中 { state.limit*(state.pager.page-1) + 1
            }〜{ state.limit*(state.pager.page-1) + state.pager.items.length }件
          </p>
        </div>
        <!--/.container_sort-->

        <template if="{ state.ads.length > 0}">
          <ad-item-tag
            api="{api}"
            ad="{ad}"
            idx="{i}"
            each="{(ad,i) in state.ads}"
            on-interest="{ onInterest }"
          ></ad-item-tag>
          <edilent-pagination-tag
            pager="{state.pager}"
            onpager="{(e,page)=>select(e,page)}"
            if="{state.pager.last > 1}"
          ></edilent-pagination-tag>
        </template>

        <div class="empty margin-spacing-3_top" if="{ state.ads.length === 0}">
          <p if="{ state.type=='interest' }" class="empty-message">
            現在あなたの「気になる」公募案件はありません。
          </p>
          <p if="{ state.type=='interested' }" class="empty-message">
            現在クライアント様からの「気になる」公募案件はありません。
          </p>
        </div>
      </div>
      <!--/.tab_contents-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import di from "dependeny-injection";
    import adItem from "@tags/pages/ad/ad-item.riot";

    export default {
      di,
      components: {
        "ad-item-tag": adItem,
      },
      state: {
        limit: 10,
        order: "0",
        ads: [],
        page: 1,
        pager: { page: 1, total: 0, last: 0, prev: 0, next: 0 },
        type: "",
      },
      select(e, page) {
        e.preventDefault();
        this.state.page = page;
        this.fetchAds();
      },
      changeOrder(e) {
        this.state.order = e.target.value;
        this.state.page = 1;
        this.fetchAds();
      },
      changeLimit(e) {
        this.state.limit = e.target.value;
        this.state.page = 1;
        this.fetchAds();
      },
      onAdsFetched(data) {
        this.update({
          ads: data.items,
          pager: data,
          page: data.page,
        });
      },
      fetchAds() {
        const params = {
          page: this.state.page,
          order: this.state.order,
          limit: this.state.limit,
          type: this.state.type,
        };
        this.api.request("index", "fetch-ads", params).then((data) => {
          this.onAdsFetched(data);
          di.SyncBox.hookHandler("interested:update");
        });
      },
      onBeforeMount(props, state) {
        this.api = di.createApi("ad");
        this.interestApi = di.createApi("interest");
        di.SyncBox.registerHooks(
          "interestedListener",
          "interested:updated",
          (interested) => this.update()
        );
        this.onUpdated(props, state);
      },
      onUnmounted(props, state) {
        di.SyncBox.unregisterHooks("interestedListener", "interested:updated");
      },
      onUpdated(props, state) {
        if (state.type != props.routeParams[0]) {
          this.state.type = props.routeParams[0];
          this.fetchAds();
        }
      },
      async onInterest(e, index) {
        if (this.state.ads[index].in_interest) {
          return;
        }
        try {
          const res = await this.interestApi.request("ad", "register", {
            ad_ids: [this.state.ads[index].ad_id],
          });
          this.state.ads[index].in_interest = true;
          this.update({ ads: this.state.ads });
          di.toast.push(`気になるを登録しました`, "success");
        } catch (e) {
          di.toast.push(e, "negative");
        }
      },
    };
  </script>
</ad-favorite-tag>
